<template>

	<b-card class="shadow-sm">

		<!-- Sale stamp -->
		<span class="sale-stamp">Sale!</span>

		<!-- Offer image -->
		<div class="image-container">
			<a :href="offer.route.url">
				<img class="lazy w-100 m-auto" :data-src="image" :alt="offer.title">
			</a>
		</div>

		<!-- Offer name -->
		<div class="mx-auto text-center">
			<h5 class="product-name">{{ offer.title }}</h5>

			<p>
				<del><small>{{ originalPrice }}</small></del>
				<span class="text-danger">{{ salePrice || originalPrice }}</span>
			</p>

			<slot name="button">
				<b-button variant="primary" @click="handleButtonClick">Buy Now</b-button>
			</slot>
		</div>

	</b-card>

</template>

<script>

	import t from 'typy';

	export default {
		props: {
			offer: Object
		},

		computed: {
			image() {
				return t(this, 'offer.media[0].url').safeObject || this.managed('/sculptnation/img/placeholders/bottle.png');
			},

			originalPrice() {
				return this.offer.original_price_local.formatted;
			},

			salePrice() {
				return this.offer.price_local.amount.formatted;
			},
		},

		methods: {
			handleButtonClick() {
				window.location.href = this.offer.route.url;
			}
		},
	}

</script>

<style lang="scss" scoped>

	.card {
		max-width: 300px;
		flex-grow: 1;
		height: 100%;
		margin: 0 auto;
	}

	.card-body {
		display: flex;
		flex-flow: column;
	}

	.card:hover {
		transform: scale(1.02);
	}

	.image-container {
		flex: 2;
		display: flex;
		align-items: center;
	}

	.product-name {
		font-size: 1rem;
		margin-top: 0.5rem;
	}

</style>
